import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import Button from '@sharedComponents/Button';
import FlexBox from '@sharedComponents/FlexBox';
import Panel from '@sharedComponents/Panel';
import Sidebar from '@sharedComponents/Sidebar';
import Table from '@sharedComponents/Table';
import Typography from '@sharedComponents/Typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { orderPlatformsProductionFirst } from '../../helpers';
import { getPlatformColumns } from '../../shared/PlatformRow';
import PlatformFormPanel from '../PlatformFormPanel';

const PlateformesTab = ({
    platforms = [],
    loading = false,
    onAddPlatform = () => {},
    onViewPlatform = () => {},
    canAddPlatform = true,
    initialAddOpen = false,
} = {}) => {
    const { t } = useTranslation('bo');
    const [addOpen, setAddOpen] = useState(initialAddOpen);

    const ordered = orderPlatformsProductionFirst(platforms);
    // Same table as the "By platform" tab of the client list, without the client columns.
    const columns = getPlatformColumns(t, {
        withClient: false,
        onViewPlatform: (clientUuid, platformUuid) => onViewPlatform(platformUuid),
    });

    const handleAdd = async (platform) => {
        await onAddPlatform(platform);
        setAddOpen(false);
    };

    return (
        <FlexBox flexDirection="column" gap="m">
            {canAddPlatform && (
                <FlexBox justifyContent="flex-end">
                    <Button icon={faPlus} label={t('Add a platform')} action={() => setAddOpen(true)} />
                </FlexBox>
            )}

            <Panel>
                {!loading && ordered.length === 0 ? (
                    <FlexBox justifyContent="center" additionnalStyles={{ padding: 'var(--space-xl)' }}>
                        <Typography color="neutral-secondary">{t('No platform yet.')}</Typography>
                    </FlexBox>
                ) : (
                    <Table columns={columns} items={ordered} loading={loading} borderless getRowKey={(item) => item.uuid} />
                )}
            </Panel>

            <Sidebar isOpened={addOpen} onClose={() => setAddOpen(false)} title={t('Add a platform')}>
                <PlatformFormPanel onCreate={handleAdd} />
            </Sidebar>
        </FlexBox>
    );
};

export default PlateformesTab;
